var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldColorSwatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5a2.5 2.5 0 0 1-2.5 2.5h-7.14c-.89 0-1.33-1.07-.71-1.7l5.87-6c.19-.19.45-.3.71-.3h1.27a2.5 2.5 0 0 1 2.5 2.5v3zM15.66 14l-2.46 2.45c-.63.63-1.71.19-1.71-.7V7.26c0-.27.11-.52.29-.71l.92-.92c.98-.98 2.56-.98 3.54 0l2.12 2.12c.99.98.99 2.56.01 3.54L15.66 14z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2C3 2 2 3 2 4.5V18c0 .27.03.54.08.8.03.13.06.26.1.39.05.15.1.3.16.44.007.007.01.013.01.02.01 0 .01 0 0 .01.14.28.3.55.49.8.11.13.22.25.33.37.11.12.23.22.36.32l.01.01c.25.19.52.35.8.49.01-.01.01-.01.01 0 .15.07.3.12.46.17.13.04.26.07.39.1.26.05.53.08.8.08.41 0 .83-.06 1.22-.19.11-.04.22-.08.33-.13.35-.14.69-.34.99-.6.09-.07.19-.16.28-.25l.04-.04C9.56 20.07 10 19.08 10 18V4.5C10 3 9 2 7.5 2h-3zm0 16c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldColorSwatch);
export default __webpack_public_path__ + "static/media/vuesax-bold-color-swatch.27d3bdac842b02082a3d6f70672546b5.svg";
export { ForwardRef as ReactComponent };